<template>
  <v-toolbar
      color="primary"
    >
    <v-toolbar-title>Search: </v-toolbar-title>
    <v-autocomplete
              :items="filteredUsers"
              box
              chips
              color="secondary"
              item-text="name"
              item-value="name"
              multiple
            >
              <template
                slot="selection"
                slot-scope="data"
                pa-5
              >
                <!-- <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                >
                  <v-avatar>
                    <img :src="data.item.photoURL">
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip> -->
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-avatar>
                    <img :src="data.item.photoURL">
                  </v-list-tile-avatar>
                  <v-list-tile-content @click="pushProfile(data.item.id)">
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-toolbar>
</template>

<script>

import fireapp from '../../Firebase/FirebaseInit'
export default {
  data () {
    return {
      users: [],
      searchText: ''
    }
  },
  computed: {
    filteredUsers () {
      return this.users.filter((user) => {
        return user.name.toLowerCase().match(this.searchText.toLowerCase())
      })
    }
  },
  methods: {
    pushProfile (id) {
      this.$router.push('/profile/' + id)
    }
  },
  created () {
    fireapp.firestore().collection('users').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'contacts': doc.data().contacts
        }
        if ((user.name != null) && (user.id !== this.$store.getters.user.id)) {
          this.users.push(user)
        }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// Search.vue?5f92535f